import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import Checkout from "./components/Checkout";
import Success from "./components/Success";
import * as yup from "yup";
import { useFormik } from "formik";
import pagarme from "pagarme/browser";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

import {
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormGroup,
  FormHelperText,
  Switch
} from "@material-ui/core";
const ButtonClose = styled.div`
  background: var(--bg-brand-default);
  display: inline-block;
  padding: 10px 17px;
  position: absolute;
  top: -15px;
  right: -15px;
  color: var(--fg-neutral-subtler);
  font-weight: bold;
  border-radius: 50px;
  z-index: 9999;
  :hover {
    cursor: pointer;
    background-image: linear-gradient(var(--state-hover), var(--state-hover));
  }
  html[data-theme="dark"] &:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.16), rgba(0, 0, 0, 0.16));
  }
`;

const ResponsiveModal = styled(Modal)`
  .modal-body {
    padding: 40px !important;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .modal-content {
    border-radius: 10px !important;
    min-height: 80vh;
  }

  .modal-dialog {
    max-width: 700px !important;
  }

  @media screen and (max-width: 767px) {
    .modal-content {
      width: 90% !important;
      margin: 0 auto !important;
    }
  }
`;

export default function ModalSubscriptionReached(props) {
  const [screen, setScreen] = useState("checkout");
  const modalInfo = useSelector(state => state.app.modal_subscription);
  const clientSubscription = useSelector(state => state.app.client_subscription);
  const customer = useSelector(
    state => state.subscription.customer
  );
  const dispatch = useDispatch();

  const clientData = useMemo(() => ({
    id: customer?.id,
    email: customer?.email || "",
    name: customer?.name || "",
    provider: clientSubscription?.info?.provider || "pagarme_v5",
  }), [customer, clientSubscription]);
  
  const formik = useFormik({
    initialValues: {
      plan_id: null,
      plan_name: "",
      plan_amount: null,
      plan_periodicity: "",
      
      cardholder_name: "",
      card_number: "",
      card_payment_method: null,
      card_cvv: "",
      card_expiration: "",
      card_selected: null
    },
    onSubmit: (values, { setSubmitting }) => {

      const newCard = values.card_selected === null;
      const isBoleto = values.card_selected === "boleto";
      const newPlanData = {
        id: values.plan_id,
        name: values.plan_name,
        amount: values.plan_amount,
        periodicity: values.plan_periodicity,
      };

      const currentPlanData = {
        id: clientSubscription?.plan_details?.id,
        name: clientSubscription?.plan_details?.name,
        amount: clientSubscription?.plan_details?.amount,
        provider: clientSubscription?.info?.provider,
        periodicity: clientSubscription?.plan_details?.periodicity
      };

      if (values.card_selected === null) {
        var card = {};
        card.card_holder_name = values.cardholder_name;
        card.card_expiration_date =
          values.card_expiration.substr(0, 2) +
          "/" +
          values.card_expiration.substr(values.card_expiration.length - 2);
        card.card_number = values.card_number;
        card.card_cvv = values.card_cvv;
        var cardValidations = pagarme.validate({ card: card });

        let hasError = false;
        let errorMessage = "";
        if (!cardValidations.card.card_holder_name) {
          setSubmitting(false);
          toast.error("Verifique o nome impresso no cartão.");
          errorMessage = "nome do titular do cartão não informado";
          hasError = true;
        }
        if (!cardValidations.card.card_number) {
          setSubmitting(false);
          toast.error("Verifique o número do cartão.");
          errorMessage = "número do cartão não informado";
          hasError = true;
        }
        if (!cardValidations.card.card_expiration_date) {
          setSubmitting(false);
          toast.error("Verifique a data de expiração do cartão.");
          errorMessage = "data de expiração do cartão não informada";
          hasError = true;
        }
        if (!cardValidations.card.card_cvv) {
          setSubmitting(false);
          toast.error("Verifique o código de segurança (CVV) do cartão.");
          errorMessage = "CVV do cartão não informado";
          hasError = true;
        }

        if (hasError) {
          return false;
        }

        if (clientSubscription.info.provider === "pagarme_v5") {
          const options = {
            method: "POST",
            headers: {
              accept: "application/json",
              "content-type": "application/json"
            },
            body: JSON.stringify({
              type: "card",
              card: {
                number: card.card_number.replace(/\s/g, ""),
                holder_name: card.card_holder_name,
                exp_month: parseInt(card.card_expiration_date.substr(0, 2), 10),
                exp_year: parseInt(card.card_expiration_date.substr(3, 2), 10),
                cvv: card.card_cvv,
              }
            }),
          };
          fetch(`https://api.pagar.me/core/v5/tokens?appId=${process.env.REACT_APP_PAGARME_V5_ENCRYPTION_KEY}`, options)
            .then(response => {
              if (!response.ok) {
                throw new Error("Erro ao gerar token do cartão.");
              }
              return response.json();
            })
            .then(data => dispatch({
              type: "CREATE_SUBSCRIPTION",
              payload: {
                values: {
                  ...values,
                  card_hash: data.id,
                  client_id: modalInfo.client_id
                },
                callback: (response) => {
                  if (response.success) setScreen("success");
                },
                setSubmitting
              }
            }))
            .catch(() => {
              setSubmitting(false);
              toast.error("Falha ao adicionar cartão. Por favor, tente novamente.");
            })
            .finally(() => setSubmitting(false));
        }
        else {
        //Mas caso esteja tudo certo, você pode seguir o fluxo
          pagarme.client
            .connect({
              encryption_key: process.env.REACT_APP_PAGARME_ENCRYPTION_KEY
            })
            .then(client => client.security.encrypt(card))
            .then(card_hash => {
              dispatch({
                type: "CREATE_SUBSCRIPTION",
                payload: {
                  values: {
                    ...values,
                    card_hash: card_hash,
                    client_id: modalInfo.client_id
                  },
                  callback: (response) => {
                    if (response.success) setScreen("success");
                  },
                  setSubmitting,
                  onError: (error) => {
                    Sentry.withScope(function(scope) {
                      scope.setTag("flow", "upgrade_plan");
                      scope.setTag("payment_method", isBoleto ? "boleto" : newCard ? "new_card" : "existing_card");
                      scope.setExtra("clientData", clientData);
                      scope.setExtra("currentPlanData", currentPlanData);
                      scope.setExtra("newPlanData", newPlanData);
                      scope.setTag("provider", clientData.provider);
                      const sanitized = new Error("Create subscription failed on polling");
                      sanitized.name = error.name ?? "Error";
                      Sentry.captureException(sanitized);
                    });
                  }
                }
              });
            })
            .catch(() => {
              setSubmitting(false);
              toast.error("Falha ao adicionar cartão. Por favor, tente novamente.");
            });
        }
      } else {
        dispatch({
          type: "CREATE_SUBSCRIPTION",
          payload: {
            values: {
              ...values,
              client_id: modalInfo.client_id
            },
            callback: (response) => {
              if (response.success) setScreen("success");
            },
            setSubmitting,
            onError: (error) => {
              Sentry.withScope(function(scope) {
                scope.setTag("flow", "upgrade_plan");
                scope.setTag("payment_method", isBoleto ? "boleto" : newCard ? "new_card" : "existing_card");
                scope.setExtra("clientData", clientData);
                scope.setExtra("currentPlanData", currentPlanData);
                scope.setExtra("newPlanData", newPlanData);
                scope.setTag("provider", clientData.provider);
                const sanitized = new Error("Create subscription failed on polling");
                sanitized.name = error.name ?? "Error";
                Sentry.captureException(sanitized);
              });
            }
          }
        });
      }
    },
    validationSchema: yup.object().shape({
      plan_id: yup
        .object()
        .nullable()
        .required("Escolha o plano!"),
      cardholder_name: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O nome do titular do cartão é obrigatório.")
      }),
      card_number: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O número do cartão é obrigatório.")
          .test("isValidCardNumber", "Número do cartão inválido.", function(
            value
          ) {
            return value && value.length === 19;
          })
      }),
      card_expiration: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O mês/ano de expiração do cartão é obrigatório.")
          .test("isValidExpiration", "O vencimento é inválido.", function(
            value
          ) {
            return value && /^(0[1-9]|1[012]) [/] \d{2}/.test(value);
          })
      }),
      card_cvv: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O código de segurança (CVV) do cartão é obrigatório.")
          .test("isValidCVV", "Número do CVV inválido.", function(value) {
            return value && /^[0-9]{3,4}$/.test(value);
          })
      })
    })
  });

  const closeModal = () => {
    setScreen("checkout");
    modalInfo.callback();
    dispatch({ type: "CLOSE_MODAL_SUBSCRIPTION" });
  };

  return (
    <ResponsiveModal
      show={modalInfo.visible}
      onHide={closeModal}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ButtonClose onClick={closeModal}>X</ButtonClose>

      <Modal.Body>
        {screen == "checkout" && (
          <Checkout
            screen={screen}
            setScreen={setScreen}
            formik={formik}
            back={() => setScreen("checkout")}
          />
        )}
        {screen == "success" && (
          <Success screen={screen} setScreen={setScreen} />
        )}
      </Modal.Body>
    </ResponsiveModal>
  );
}
